import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Documents } from "@/components/site/Documents";
import { Why } from "@/components/site/Why";
import { Reviews } from "@/components/site/Reviews";
import { Contact } from "@/components/site/Contact";
import { CookieNotice } from "@/components/site/CookieNotice";
import Datenschutz from "@/pages/Datenschutz";
import Impressum from "@/pages/Impressum";
import Preise from "@/pages/Preise";
import Storno from "@/pages/Storno";
import { BookingProvider } from "@/components/site/BookingDialog";
import { BUSINESS } from "@/lib/business";

const Footer = () => (
  <footer className="bg-navy text-steel border-t border-white/10 py-8">
    <div className="max-w-6xl mx-auto px-6 flex flex-wrap gap-4 justify-between lb">
      <span data-testid="footer-name">{BUSINESS.fullName} · {BUSINESS.street}, {BUSINESS.city}</span>
      <div className="flex gap-6">
        <Link to="/impressum" className="hover:text-white transition-colors" data-testid="footer-impressum-link">Impressum</Link>
        <Link to="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Datenschutz</Link>
        <a href="/#top" className="hover:text-white transition-colors" data-testid="footer-top-link">Nach oben</a>
      </div>
    </div>
  </footer>
);

const Home = () => (
  <main id="top">
    <Hero />
    <Marquee />
    <Documents />
    <Why />
    <Reviews />
    <Contact />
  </main>
);

function App() {
  return (
    <BrowserRouter>
      <BookingProvider>
      <div className="pc-root bg-paper text-ink">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/preise" element={<Preise />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/storno/:id" element={<Storno />} />
        </Routes>
        <Footer />
        <CookieNotice />
        <Toaster position="top-center" />
      </div>
      </BookingProvider>
    </BrowserRouter>
  );
}

export default App;
